module.exports = __webpack_public_path__ + "img/textura_ganhador_sorteio.54b28e3a.png";